const SIZE_XSMALL = 'xsmall'
const SIZE_SMALL = 'small'
const SIZE_MEDIUM = 'medium'

export const BUTTON_SIZES = [SIZE_XSMALL, SIZE_SMALL, SIZE_MEDIUM] as const

export type ButtonSize = (typeof BUTTON_SIZES)[number]

// `xsmall` is styled in Button.module.scss but has no icon sizing, so its
// entry is explicitly undefined and the icon keeps its own default. Spelling
// it out keeps the maps total, which is what makes `ICON_SIZES[size]`
// type-check for any ButtonSize.
export const ICON_SIZES = {
  [SIZE_XSMALL]: undefined,
  [SIZE_MEDIUM]: 24,
  [SIZE_SMALL]: 19,
} as const satisfies Record<ButtonSize, number | undefined>

export const LOCK_ICON_SIZES = {
  [SIZE_XSMALL]: undefined,
  [SIZE_MEDIUM]: 20,
  [SIZE_SMALL]: 16,
} as const satisfies Record<ButtonSize, number | undefined>
